<template>
  <div class="phone">
    <section class="buttons" v-if="btnShow">
      <div>
        <el-button @click="lastStep">{{ $t('app.prevStep') }}</el-button>
        <el-button type="primary" @click="exportJSON">{{ $t('app.auto_345_e6900270') }}</el-button>
      </div>
    </section>
    <div class="phone-all">
      <img src="@/assets/images/phoneTop.png" alt="" class="statusBar" />
      <!-- 头部导航 -->
      <headerTop :pageSetup="pageSetup" @click.native="headTop" />
      <section
        class="phone-container"
        :style="{
          'background-color': pageSetup.bgColor,
          backgroundImage: 'url(' + pageSetup.bgImg + ')'
        }"
      >
        <component
          :is="item.component"
          v-for="(item, index) in pageComponents"
          :key="index"
          :datas="item.setStyle"
          :style="{
            border: item.active && deleShow ? '2px solid #155bd4' : ''
          }"
          class="componentsClass"
          :data-type="item.type"
        >
        </component>
      </section>
    </div>
  </div>
</template>

<script>
import jsonData from "@/utils/pageComInfo.json"; // JSON数据
import { addActivity } from "@/api/SaleCenter";
import { getBasicUrls } from "@/util/config";

export default {
  name: "previewPage",
  props: {
    activityData: Object,
    previewData: Object,
    btnShow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      pageSetup: {},
      pageComponents: [], //页面组件
      deleShow: false
    };
  },
  components: {},
  mounted() {
    this.pageComponents = JSON.parse(this.previewData.component);
    this.pageSetup = JSON.parse(this.previewData.templateJson);
  },
  methods: {
    // 上传信息
    exportJSON() {
      // 将json转换成字符串

      const params = {
        activityName: this.activityData.promotionName,
        beginTime: this.activityData.promotionTime[0] || "",
        endTime: this.activityData.promotionTime[1] || "",
        shareCardTitle: this.activityData.shareCardTitle,
        shareCardDesc: this.activityData.shareCardDesc,
        timeless: this.activityData.promotionFstore,
        shareCardStyle: JSON.stringify(this.previewData),
        activityLink: getBasicUrls().appUrl + 'introductionTool'
      };
      addActivity(params).then(res => {
        if (res.data) {
          this.$message({
            message: this.$t('app.publishSuccess'),
            type: "success"
          });
          this.$router.go(-1);
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      });
    },
    // 上一级
    lastStep() {
      this.$emit("lastStep");
    }
  }
};
</script>
<style scoped lang="scss">
.phone {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  /* 按钮集合 */
  .buttons {
    width: 100%;
    background: #fff;
    height: 8%;
    border-bottom: 1px solid #ebedf0;
    display: flex;
    justify-content: end;
    box-sizing: border-box;
    padding-right: 15px;
    align-items: center;
    padding: 20px;
  }
  &-all {
    width: 375px;
    min-height: 760px;
    box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.1);
    margin: 45px 0;
    position: relative;
    border-radius: 20px;
  }
  &-container {
    min-height: 603px;
    box-sizing: border-box;
    cursor: pointer;
    width: 100%;
    position: relative;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  /* 状态栏 */
  .statusBar {
    width: 100%;
    display: block;
  }
}
</style>
